import useSWR, { SWRResponse } from 'swr';
import { ConversationTemplateFilters, getConversationTemplates } from '../../../providers/api/conversation/conversationProvider';
import { ConversationTemplate } from '../../../providers/api/dtos/conversationTemplate';

export const CONVERSATION_TEMPLATES_RID = '/conversations/templates';

export default function useConversationTemplates(filters?: ConversationTemplateFilters): SWRResponse<ConversationTemplate[], Error> {
  return useSWR([CONVERSATION_TEMPLATES_RID], () => getConversationTemplates(filters));
}
